import React from 'react';

const Logo = ({ className = "", width = "150", height = "150" }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 300 300" 
      className={className}
      width={width} 
      height={height}
    >
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0ea5e9" />
          <stop offset="100%" stopColor="#0284c7" />
        </linearGradient>
      </defs>
      <path 
        d="M150,30 C80,30 30,80 30,150 C30,220 80,270 150,270 C220,270 270,220 270,150" 
        stroke="url(#logoGradient)" 
        strokeWidth="10" 
        fill="none" 
      />
      <path 
        d="M270,150 C270,140 268,130 265,120 L265,120 Q265,160 230,180 Q210,190 210,220 Q210,240 230,250" 
        stroke="url(#logoGradient)" 
        strokeWidth="10" 
        fill="none" 
      />
      <text x="80" y="160" fontSize="70" fontWeight="bold" fontFamily="serif">H2A</text>
      <text x="90" y="100" fontSize="24" fontWeight="bold" textAnchor="middle">HOW TO APPLY</text>
      <text x="145" y="190" fontSize="16" fontStyle="italic">... its a click away</text>
      <circle cx="230" cy="250" r="10" fill="#0284c7" />
    </svg>
  );
};

export default Logo;